import { useMutation } from "@tanstack/react-query";

import useFetch from "../lib/useFetch";
import { IOrder } from "../types/order";
import { useParams } from "react-router-dom";

const API = process.env.REACT_APP_API;

const useCreateOrder = () => {
  const { slug } = useParams();
  const fetch = useFetch();
  const mutationFn = (order: IOrder) => {
    if (!slug) {
      return Promise.resolve(null);
    }

    return fetch(`${API}/api/feira_online/seeds/${slug}/orders`, {
      method: "POST",
      body: order,
    });
  };

  return useMutation(["create_order"], mutationFn);
};

export default useCreateOrder;
